import { useState } from "react";
import AccordionMenu from "components/Accordion";
import styles from "./style.module.scss";
import { ReactComponent as ArrowIcon } from "assets/icons/bottom_arrow.svg";
import { Button } from "components";
import { ReactComponent as PlusIcon } from "assets/icons/plus-icon.svg";
import { useHistory, useParams } from "react-router-dom";

const AccordionTable = ({ report, tableComponent }: any) => {
    const [isOpen, setIsOpen] = useState<boolean>(report.active);
    const { vendorID, periodID } = useParams<{
        vendorID: string;
        periodID: string;
    }>();

    let history = useHistory();

    const addOtheButton = report?.type === "other" && (
        <Button
            className={`is-green`}
            btnText="اضافه کردن پرداختی جدید"
            handleClick={() =>
                history.push(`/add-new-payment/${periodID}/${vendorID}`)
            }
            btnIcon={<PlusIcon className={`ml-2 ${styles.iconColor}`} />}
        />
    );

    const paymentReportSections = {
        title: (
            <div
                className={styles.tableAccordionButton}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <ArrowIcon
                    className={`${styles.iconColor} ${
                        isOpen ? styles.rotateIcon : ""
                    }`}
                />
            </div>
        ),
        header: (
            <div className={styles.tableHeaderCustom}>
                <div className={styles.tableHeaderText}>{report.title}</div>
                {addOtheButton}
            </div>
        ),
        content: tableComponent,
        activeKey: isOpen ? "0" : "1",
    };

    return (
        <div className={styles.accordionContainer}>
            <AccordionMenu
                section={paymentReportSections}
                customContainerClass={styles.customAccordion}
                customAccordionHeader={styles.customAccordionHeader}
                customAccordionContainer={styles.customAccordionContainer}
                customAccordionCollapse={styles.customAccordionCollapse}
            />
        </div>
    );
};

export default AccordionTable;
